<template>
  <div class="project_box">
    <div class="w3l-homeblog py-5" id="homeblog">
      <div class="container py-lg-5 py-md-4">
        <div class="header-title mb-3">
          <span class="sub-title">产品中心</span>
          <!-- <h3 class="hny-title text-left">Browse Our Top Courses.</h3> -->
        </div>
        <div class="row top-pics">
           <!-- @click="jupt(item.id)" -->
          <div
            class="col-lg-3 col-md-6 mt-5"
           
            v-for="(item, index) in projectList"
            :key="index"
          >
          <router-link :to="'/project_info' + '?projectid=' + item.id">
            <div
              class="top-pic1"
              :style="{ backgroundImage: 'url(' + item.picUrl + ')' }"
              style="background-size: 90% 60%;background-repeat: no-repeat;background-position-x: center;background-position-y: center;"
            >
              <div style="height:68px;" class="card-body blog-details">
                <a class="blog-desc">{{ item.productName }} </a>
                <div class="align-items-center">
                  <ul class="blog-meta">
                    <ul class="blog-meta">
                      <li class="meta-item blog-lesson">
                        <span class="meta-value">
                          {{ projectShiyingzheng(item.indication)  }}
                        </span>
                      </li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>
          </router-link>
          </div>

          <div class="readhny-btm text-center mx-auto mt-md-4">
            <router-link
              class="btn btn-primary btn-style mt-md-5 mt-4"
              to="/project"
            >
              查看更多
              <span class="fa fa-chevron-right ml-2" aria-hidden="true"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectList } from "@/api/project/index";
export default {
  data() {
    return {
      projectList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 8,
      },
      srcImgUrl: "",
    };
  },
  mounted() {
    this.getprojectList();
  },
  methods: {
    projectShiyingzheng(text){
      if(text != null){
        return text.substring(0,20)
      }else{
        return "暂无资料"
      }
    },
    getprojectList() {
      projectList(this.queryParams).then((res) => {
        this.projectList = res.rows;
      });
    },
    jupt(e) {
      this.$router.push({
        path: "/project_info",
        name: "projectInfo",
        params: {
          project_id: e,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
  .top-pic1::before{
    background: none;
    -moz-box-shadow:2px 2px 5px #333333; -webkit-box-shadow:2px 2px 5px #333333; box-shadow:2px 2px 5px #333333;
  }
  .blog-details a{
    color: #333;
  }
  .w3l-homeblog span.meta-value{
    color: #333;
  }
</style>